import { Icon } from '@iconify/react'
import { Select } from '@/components/Select'
import { DONOR_PRIZE_STATUS_LABELS, type DonorPrizeStatus, type RoulettePrizeType } from '@/lib/roulette'
import type { DistributedPrizesFiltersState } from '@/lib/distributed-prizes-filters'
import styles from './RoletaDistributedPrizesFilters.module.css'

export interface RoletaDistributedPrizesFiltersProps {
  value: DistributedPrizesFiltersState
  emailInput: string
  onEmailInputChange: (next: string) => void
  onChange: (next: DistributedPrizesFiltersState) => void
  onClear: () => void
}

const STATUS_OPTIONS: { value: DonorPrizeStatus | ''; label: string }[] = [
  { value: '', label: 'Todos' },
  { value: 'pending', label: DONOR_PRIZE_STATUS_LABELS.pending },
  { value: 'used', label: DONOR_PRIZE_STATUS_LABELS.used },
  { value: 'paid', label: DONOR_PRIZE_STATUS_LABELS.paid },
  { value: 'no_prize', label: DONOR_PRIZE_STATUS_LABELS.no_prize },
]

const PRIZE_TYPE_OPTIONS: { value: RoulettePrizeType | ''; label: string }[] = [
  { value: '', label: 'Todos' },
  { value: 'coupon', label: 'Cupom' },
  { value: 'lucky_number', label: 'Número da sorte' },
  { value: 'pix', label: 'PIX' },
  { value: 'none', label: 'Sem prêmio' },
]

export function RoletaDistributedPrizesFilters({
  value,
  emailInput,
  onEmailInputChange,
  onChange,
  onClear,
}: RoletaDistributedPrizesFiltersProps) {
  return (
    <section className={styles.panel} aria-label="Filtros de prêmios distribuídos">
      <div className={styles.head}>
        <div className={styles.headLeft}>
          <Icon icon="mdi:filter-variant" className={styles.headIcon} aria-hidden />
          <h4 className={styles.title}>Filtros</h4>
        </div>
        <button type="button" className={styles.btnClear} onClick={onClear}>
          Limpar
        </button>
      </div>

      <div className={styles.body}>
        <div className={styles.cell}>
          <Select
            id="roleta-distributed-status-filter"
            className={styles.select}
            label="Status"
            value={value.status}
            onChange={(next) =>
              onChange({
                ...value,
                status: next as DonorPrizeStatus | '',
              })
            }
            options={STATUS_OPTIONS}
            icon="mdi:flag-outline"
          />
        </div>

        <div className={styles.cell}>
          <Select
            id="roleta-distributed-prize-type-filter"
            className={styles.select}
            label="Tipo de prêmio"
            value={value.prizeType}
            onChange={(next) =>
              onChange({
                ...value,
                prizeType: next as RoulettePrizeType | '',
              })
            }
            options={PRIZE_TYPE_OPTIONS}
            icon="mdi:gift-outline"
          />
        </div>

        <div className={styles.cell}>
          <label className={styles.fieldLabel} htmlFor="roleta-distributed-email-filter">
            E-mail do comprador
          </label>
          <div className={styles.emailField}>
            <Icon icon="mdi:email-outline" className={styles.emailIcon} aria-hidden />
            <input
              id="roleta-distributed-email-filter"
              type="search"
              className={styles.textInput}
              value={emailInput}
              onChange={(event) => onEmailInputChange(event.target.value)}
              placeholder="Buscar por e-mail"
              autoComplete="off"
            />
          </div>
        </div>

        <div className={styles.cell}>
          <span className={styles.fieldLabel}>Data da distribuicao</span>
          <div className={styles.datePair}>
            <input
              type="date"
              className={styles.dateInput}
              value={value.dateFrom}
              onChange={(event) =>
                onChange({ ...value, dateFrom: event.target.value })
              }
              aria-label="Data inicial"
            />
            <span className={styles.dateSep} aria-hidden>
              —
            </span>
            <input
              type="date"
              className={styles.dateInput}
              value={value.dateTo}
              onChange={(event) =>
                onChange({ ...value, dateTo: event.target.value })
              }
              aria-label="Data final"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
